/**
 * Module-level cache cho navMenu data theo từng ngôn ngữ.
 * Header fetch và lưu vào đây. Các page component đọc để lấy base path.
 */
const cache = {};

/** Cache raw API data (kèm children) theo từng ngôn ngữ */
const rawCache = {};

/** Lưu navMenu data của một ngôn ngữ vào cache */
export function cacheNavMenu(lang, data) {
    cache[lang] = data;
}

/** Lưu raw navMenu data (kèm children) vào cache */
export function cacheNavMenuRaw(lang, data) {
    rawCache[lang] = data;
}

/**
 * Lấy slug (base path) của một menu item theo keyName và ngôn ngữ.
 * Fallback về VI nếu chưa có cache cho ngôn ngữ đó.
 * @param {string} keyName - vd: 'menu.products', 'menu.investment'
 * @param {string} lang    - vd: 'vi', 'en', 'jp'
 * @returns {string|null}
 */
export function getBasePathByKeyName(keyName, lang) {
    const menuData = rawCache[lang] || rawCache['vi'] || [];
    const item = menuData.find(m => m.keyName === keyName);
    return item ? item.slug : null;
}

/**
 * Tìm child nav menu item theo slug của child, trong parent được xác định bởi keyName.
 * @param {string} parentKeyName - keyName của parent, vd: 'menu.investment'
 * @param {string} childSlug     - slug của child trong ngôn ngữ hiện tại
 * @param {string} lang          - ngôn ngữ, vd: 'vi', 'en'
 * @returns {{ id: number, keyName: string, slug: string, title: string }|null}
 */
export function getNavMenuChildBySlug(parentKeyName, childSlug, lang) {
    const menuData = rawCache[lang] || rawCache['vi'] || [];
    const parent = menuData.find(m => m.keyName === parentKeyName);
    if (!parent || !parent.children) return null;
    return parent.children.find(c => c.slug === childSlug) || null;
}

/**
 * Tìm child nav menu item theo ID của child.
 * @param {string} parentKeyName - keyName của parent, vd: 'menu.investment'
 * @param {number} childId       - ID của child menu item
 * @param {string} lang          - ngôn ngữ, vd: 'vi', 'en'
 * @returns {{ id: number, keyName: string, slug: string, title: string }|null}
 */
export function getNavMenuChildById(parentKeyName, childId, lang) {
    const menuData = rawCache[lang] || rawCache['vi'] || [];
    const parent = menuData.find(m => m.keyName === parentKeyName);
    if (!parent || !parent.children) return null;
    return parent.children.find(c => c.id === childId) || null;
}

